<template>
  <div class="home">
    Hey this is the hash app
  </div>
</template>


